import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'pl', label: 'Polski' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-full border border-background-300/60 bg-background-50 px-3 py-1.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 whitespace-nowrap cursor-pointer"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <i className="ri-global-line text-base" aria-hidden="true"></i>
        <span>{current.label}</span>
        <i className={`ri-arrow-down-s-line text-base transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true"></i>
      </button>

      {open && (
        <ul
          className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1"
          role="listbox"
        >
          {languages.map((lang) => (
            <li key={lang.code}>
              <button
                type="button"
                onClick={() => {
                  i18n.changeLanguage(lang.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center justify-between px-4 py-2 text-sm text-left transition-colors hover:bg-background-100 whitespace-nowrap cursor-pointer ${
                  lang.code === i18n.language
                    ? 'font-semibold text-primary-700'
                    : 'text-foreground-700'
                }`}
              >
                <span>{lang.label}</span>
                {lang.code === i18n.language && (
                  <i className="ri-check-line text-primary-600" aria-hidden="true"></i>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}